const commonHeaders = {'X-Requested-With': 'XMLHttpRequest'};

class FeatureAvailabeService {
    isSsoEnabled = async () => {
        return await getIsSsoEnabled();
    }
}

export function getIsSsoEnabled() {
    return fetch('/api/features/polar-sso/available', {
        credentials: 'same-origin', 
        headers: {...commonHeaders}
    }).then((response) => {
        if (response && response.ok) {
            return response.json();
        }
    }).then((data) => {
        if(data) {
            return data['available'];
        }
    })
    .catch(e => console.error('Failed to get feature available flag', e));
}

export default new FeatureAvailabeService();


// WEBPACK FOOTER //
// ./src/FeatureAvailableService.js